'use client'
import React, { createContext, useContext } from 'react';
import type { PanelRow } from '@/panelData';

export interface LocaleData {
  locale: string;
  // Translated replacements for chart components embedded in markdown,
  // keyed by directive name as used in Markdown.tsx.
  components: Record<string, React.ComponentType>;
  panelData: PanelRow[];
}

export const LocaleContext = createContext<LocaleData | null>(null);

export const useLocale = () => useContext(LocaleContext);
